import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

import { CasinoFilterForm, LiveCasinoFilterForm } from "./tabs";

export default function GamingHistoryTabs() {
	let url = "";

	if (WEBPACK_IS_CASINO_ENABLED) {
		url = `/${getCurrentCulture()}/gaming-history/games`;
	} else if (WEBPACK_IS_CASINO_LIVE_ENABLED) {
		url = `/${getCurrentCulture()}/gaming-history/live-games`;
	} else {
		url = `/${getCurrentCulture()}/${DefaultPath.HOME}`;
	}

	return (
		<Switch>
			{WEBPACK_IS_CASINO_ENABLED ? (
				<Route exact path={["/:culture/gaming-history/games"]}>
					<CasinoFilterForm />
				</Route>
			) : null}

			{WEBPACK_IS_CASINO_LIVE_ENABLED ? (
				<Route exact path={["/:culture/gaming-history/live-games"]}>
					<LiveCasinoFilterForm />
				</Route>
			) : null}

			<Redirect to={url} />
		</Switch>
	);
}
